import {
  SET_PAYFAC_INVOICES,
  UPDATE_INVOICE_AMOUNT,
  PAYFAC_GET_TOKENIZATION_URL_REQUEST,
  PAYFAC_GET_TOKENIZATION_URL_SUCCESS,
  PAYFAC_GET_TOKENIZATION_URL_ERROR,
  PAYFAC_SEND_TOKENIZATION_EMAIL_REQUEST,
  PAYFAC_SEND_TOKENIZATION_EMAIL_SUCCESS,
  PAYFAC_SEND_TOKENIZATION_EMAIL_ERROR,
  PAYFAC_GET_CUSTOMER_CARDS_REQUEST,
  PAYFAC_GET_CUSTOMER_CARDS_SUCCESS,
  PAYFAC_GET_CUSTOMER_CARDS_ERROR,
  PAYFAC_DELETE_CARD_REQUEST,
  PAYFAC_DELETE_CARD_SUCCESS,
  PAYFAC_DELETE_CARD_ERROR,
  PAYFAC_TOGGLE_AUTOPAY_REQUEST,
  PAYFAC_TOGGLE_AUTOPAY_SUCCESS,
  PAYFAC_TOGGLE_AUTOPAY_ERROR,
  PORTAL_GET_CARDS_REQUEST,
  PORTAL_GET_CARDS_SUCCESS,
  PORTAL_GET_CARDS_ERROR,
  PORTAL_TOGGLE_AUTOPAY_SUCCESS,
  PORTAL_CHARGE_CARD_REQUEST,
  PORTAL_CHARGE_CARD_SUCCESS,
  PORTAL_CHARGE_CARD_ERROR
} from '../actions/payfacActions';

const initialState = {
  invoicesToPay: [],
  tokenizationUrl: null,
  tokenizationUrlLoading: false,
  tokenizationEmailSending: false,
  customerCards: [],
  customerCardsCount: 0,
  customerCardsPages: 0,
  customerCardsLoading: false,
  cardDeleting: null,
  autopayToggling: null,
  portalCards: [],
  portalCardsCount: 0,
  portalCardsPages: 0,
  portalCardsLoading: false,
  portalCharging: false
};

const payfacReducer = (state = initialState, action) => {
  switch (action.type) {
    // --- Existing ---
    case SET_PAYFAC_INVOICES:
      return { ...state, invoicesToPay: action.payload };

    case UPDATE_INVOICE_AMOUNT:
      return {
        ...state,
        invoicesToPay: state.invoicesToPay.map(invoice => {
          if (invoice.uuid === action.payload.invoiceUuid) {
            return { ...invoice, amountToPay: action.payload.amountToPay };
          }
          return invoice;
        })
      };

    // --- Tokenization URL ---
    case PAYFAC_GET_TOKENIZATION_URL_REQUEST:
      return { ...state, tokenizationUrlLoading: true, tokenizationUrl: null };

    case PAYFAC_GET_TOKENIZATION_URL_SUCCESS:
      return { ...state, tokenizationUrlLoading: false, tokenizationUrl: action.payload };

    case PAYFAC_GET_TOKENIZATION_URL_ERROR:
      return { ...state, tokenizationUrlLoading: false };

    // --- Send tokenization email ---
    case PAYFAC_SEND_TOKENIZATION_EMAIL_REQUEST:
      return { ...state, tokenizationEmailSending: true };

    case PAYFAC_SEND_TOKENIZATION_EMAIL_SUCCESS:
      return { ...state, tokenizationEmailSending: false };

    case PAYFAC_SEND_TOKENIZATION_EMAIL_ERROR:
      return { ...state, tokenizationEmailSending: false };

    // --- Customer cards ---
    case PAYFAC_GET_CUSTOMER_CARDS_REQUEST:
      return { ...state, customerCardsLoading: true };

    case PAYFAC_GET_CUSTOMER_CARDS_SUCCESS:
      return {
        ...state,
        customerCardsLoading: false,
        customerCards: action.payload.data,
        customerCardsCount: action.payload.count,
        customerCardsPages: action.payload.pages
      };

    case PAYFAC_GET_CUSTOMER_CARDS_ERROR:
      return { ...state, customerCardsLoading: false };

    // --- Delete card ---
    case PAYFAC_DELETE_CARD_REQUEST:
      return { ...state, cardDeleting: action.payload.cardUuid };

    case PAYFAC_DELETE_CARD_SUCCESS:
      return {
        ...state,
        cardDeleting: null,
        customerCards: state.customerCards.filter(c => c.uuid !== action.payload.cardUuid)
      };

    case PAYFAC_DELETE_CARD_ERROR:
      return { ...state, cardDeleting: null };

    // --- Toggle autopay ---
    case PAYFAC_TOGGLE_AUTOPAY_REQUEST:
      return { ...state, autopayToggling: action.payload.cardUuid };

    case PAYFAC_TOGGLE_AUTOPAY_SUCCESS:
      return {
        ...state,
        autopayToggling: null,
        customerCards: state.customerCards.map(c => {
          if (c.uuid === action.payload.cardUuid) {
            return { ...c, autopay: action.payload.enabled };
          }
          // Si se activa autopay en una tarjeta, desmarca todas las demás
          if (action.payload.enabled) {
            return { ...c, autopay: false };
          }
          return c;
        })
      };

    case PAYFAC_TOGGLE_AUTOPAY_ERROR:
      return { ...state, autopayToggling: null };

    // --- Portal client cards -------------------------------------------------
    case PORTAL_GET_CARDS_REQUEST:
      return { ...state, portalCardsLoading: true };

    case PORTAL_GET_CARDS_SUCCESS:
      return {
        ...state,
        portalCardsLoading: false,
        portalCards: action.payload.data,
        portalCardsCount: action.payload.count,
        portalCardsPages: action.payload.pages
      };

    case PORTAL_GET_CARDS_ERROR:
      return { ...state, portalCardsLoading: false };

    // --- Portal card charge --------------------------------------------------
    case PORTAL_CHARGE_CARD_REQUEST:
      return { ...state, portalCharging: true };

    case PORTAL_CHARGE_CARD_SUCCESS:
    case PORTAL_CHARGE_CARD_ERROR:
      return { ...state, portalCharging: false };

    // --- Portal autopay toggle (optimistic) ----------------------------------
    case PORTAL_TOGGLE_AUTOPAY_SUCCESS:
      return {
        ...state,
        portalCards: state.portalCards.map(c => {
          if (c.uuid === action.payload.cardUuid) {
            return { ...c, autopay: action.payload.enabled };
          }
          if (action.payload.enabled) {
            return { ...c, autopay: false };
          }
          return c;
        })
      };

    default:
      return state;
  }
};

export default payfacReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/payfacReducer.js